module.exports = __webpack_public_path__ + "img/octagon-half.bb64c81c.svg";